import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(activity)/french-summer-edit-glasses/ClientPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
